var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-inline-block d-flex align-center"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary",
      "elevation": "1"
    },
    on: {
      "click": function ($event) {
        return _vm.decrease(-1);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-minus")])], 1), _c('v-text-field', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "number",
      "outlined": "",
      "hide-details": "",
      "dense": ""
    },
    on: {
      "input": function ($event) {
        return _vm.update();
      }
    },
    model: {
      value: _vm.quantity,
      callback: function ($$v) {
        _vm.quantity = $$v;
      },
      expression: "quantity"
    }
  }), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary",
      "elevation": "1"
    },
    on: {
      "click": function ($event) {
        return _vm.increase(1);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }